<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="university of universities"
      :value="university"
      :key="university.code">
        {{ university.name }}
    </option>
  </select>
</template>

<script lang="ts">
import { University } from '@/store/master/types';
import { RootState } from '@/store/types';
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SelectUniversityInput extends Vue {
  @Prop() value?: University

  private get universities() {
    return (this.$store.state as RootState).master.universities
  }

  private get selected(): University|undefined {
    return this.value
  }

  private set selected(university: University|undefined) {
    this.$emit('input', university || null)
  }

  created() {
    this.$store.dispatch('fetchMasterUniversities')
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
